import appDataBase from "./app-database.jpg";
import audioPlayer from "./audio-player.jpg";
import dependencyChecker from "./dependency-checker.jpg";
import fitnessTrackerGraphql from "./fitness-tracker-graphql.jpg";
import fitnessTrackerRn from "./fitness-tracker-rn.jpg";
import hopeIsialndWebsite from "./hope-isialnd-website.jpg";
import hopeIslandGame from "./hope-island-game.jpg";
import indoorTracking from "./indoor-tracking.jpg";
import introAI from "./intro-ai.jpg";
import introDatabase from "./intro-database.jpg";
import introJava from "./intro-java.jpg";
import introNetwork from "./intro-network.jpg";
import introOS from "./intro-os.jpg";
import introUX from "./intro-ux.jpg";
import introWeb from "./intro-web.jpg";
import laxisApp from "./laxis-app.jpg";
import movieDbFlask from "./movie-db-flask.jpg";
import quizGenerator from "./quiz-generator.jpg";
import uscFilmsAngular from "./usc-films-angular.jpg";
import uscFilmsExpress from "./usc-films-express.jpg";
import uscFilmsIOS from "./usc-films-ios.jpg";
import uwCourseSearch from "./uw-course-search.jpg";
import weWish from "./we-wish.jpg";
import wiscShopChatBot from "./wisc-shop-chat-bot.jpg";
import yingjiePortfolio from "./yingjie-portfolio.jpg";

export const projects = {
  appDataBase: appDataBase,
  audioPlayer: audioPlayer,
  dependencyChecker: dependencyChecker,
  fitnessTrackerGraphql: fitnessTrackerGraphql,
  fitnessTrackerRn: fitnessTrackerRn,
  hopeIsialndWebsite: hopeIsialndWebsite,
  hopeIslandGame: hopeIslandGame,
  indoorTracking: indoorTracking,
  introAI: introAI,
  introDatabase: introDatabase,
  introJava: introJava,
  introNetwork: introNetwork,
  introOS: introOS,
  introUX: introUX,
  introWeb: introWeb,
  laxisApp: laxisApp,
  movieDbFlask: movieDbFlask,
  quizGenerator: quizGenerator,
  uscFilmsAngular: uscFilmsAngular,
  uscFilmsExpress: uscFilmsExpress,
  uscFilmsIOS: uscFilmsIOS,
  uwCourseSearch: uwCourseSearch,
  weWish: weWish,
  wiscShopChatBot: wiscShopChatBot,
  yingjiePortfolio: yingjiePortfolio,
};
